import React from 'react';
import './ChapterOpener.scss';
import InteractionContainer from '../../partials/InteractionContainer/InteractionContainer';
import Button from '../../partials/Button'
import Scroll from '../../partials/Scroll/Scroll';
import axios from "axios";

var getFileLink = (fileLocation, label = 'View file') => (
    <div className="download-link-container">
        <Button variant="link" text={label} onClick={() => {
            window.open(fileLocation, "_blank")
            // download(`docs/${`test.pdf`}`, "name.pdf")
        }} />
    </div>
);

export default function ChapterOpener(props) {
    const data = props.data;

    // if(data.markComplete){
    //     props.markComplete();
    // }
    // var downloadFileLink = (true) ? (
    //     <div className="download-link-container">
    //         <Button variant="link" text="Download" onClick={() => {
    //             download(`docs/${`test.pdf`}`, "name.pdf")
    //         }} />
    //     </div>
    // ) : null;

    return (
        <InteractionContainer withFrame={true} breadcrumbs={props.breadcrumbs}>
            <div className={`chapter-opener ${data.class}`}>
                {/* <img className="grid-background" src={'media/img/grid.png'} alt="grid background"/> */}
                {/* optional 'extras' fields - creates divs from  extras array that looks like: [{'class':"some class", "content":"Some content"}]*/}
                {Array.isArray(data.extras) && data.extras.map((extra, i) => {
                    return <div className={`extra ${extra.class} extra-${i}`}>
                        <div className="text" dangerouslySetInnerHTML={{ __html: extra.content }}></div>
                    </div>
                })}

                <div className="content-container">
                    <div className="back-btn-container">
                        <Button variant='back' text="Back" onClick={props.goBackToPreviousSegment} />
                    </div>
                    {(data.openFile !== undefined) && getFileLink(`docs/${data.openFile.name}`, data.openFile.label || data.openFile.name)}
                    <div className="chapter-opener-content">

                        <div className="text-container">

                            <h1 className="header" dangerouslySetInnerHTML={{ __html: data.header }}></h1>
                            <Scroll>
                                <div className="body" dangerouslySetInnerHTML={{
                                    __html: data.body
                                }}></div>
                            </Scroll>
                        </div>

                    </div>
                    <div className="chapter-opener-btn-container">

                        {(!data.noNext && data.flowButton) && <Button
                            id={`next-button`}
                            className="flow"
                            onClick={props.onComplete}
                            text={data.nextButton || props.globals.nextButtonText || "Next"}
                        >
                            {data.button || props.globals.nextButtonText}
                        </Button>}

                        {(!data.noNext && !data.flowButton && !data.restartButton) && <Button
                            // src={'media/img/buttons/next-btn.png'}
                            // alt="Next"
                            text={data.nextButton || props.globals.nextButtonText || "Next"}
                            id={`next-button`}
                            className="next-button"
                            onClick={props.onComplete}
                        />
                        }

                        {data.restartButton && <Button
                            className="restart-button"
                            onClick={() => props.resetSco()}
                            text="Restart"
                        >
                            <div className='restart-icon'></div>{data.button}
                        </Button>}
                        {data.courseClose && <Button
                            className="restart-button"
                            onClick={() => props.onComplete()}
                            text="Exit"
                        >
                            <div className='restart-icon'></div>{data.button}
                        </Button>}

                    </div>

                </div>
                <div className="chapter-opening-img-container">
                    {/* for image */}
                    {data.images && data.images.map((image, i) => {
                        return <img className='image' src={image.location} style={image.style} key={'image' + i} alt={'image' + i} />
                    })}
                </div>
            </div>
        </InteractionContainer>
    )
}


export var chapterOpener = (component) => (props) => {
    const [interactionIsOpen, setInteractionIsOpen] = React.useState(false);

    function itHaveChapterOpener(component) {
        return (component && component.props
            && component.props.data
            && component.props.data.ChapterOpener !== undefined
            && component.props.data.ChapterOpener.display === true)
    };

    if (itHaveChapterOpener(component))
        if (!interactionIsOpen)
            return <ChapterOpener
                data={component.props.data.ChapterOpener}
                breadcrumbs={component.props.breadcrumbs}
                goBackToPreviousSegment={component.props.goBackToPreviousSegment}
                onComplete={() => { setInteractionIsOpen(true) }}
                globals={component.props.globals}
                resetSco={component.props.resetSco}
            />;

    return component
}

function download(url, fileName) {
    axios({
        url: url,
        method: 'GET',
        responseType: 'blob'
    })
        .then((response) => {
            const url = window.URL
                .createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        })
        .catch(e => {
            console.error(e.message);
            alert('Unable to download file');
        })
}

